/**
 * Declaration for the UnityConfig type containing configuration options for the Unity WebGL instance.
 */
type UnityConfig = {
  dataUrl: string;
  frameworkUrl: string;
  codeUrl: string;
  streamingAssetsUrl: string;
  companyName: string;
  productName: string;
  productVersion: string;
  showBanner: ((msg: string, type: string) => void) | null;
  matchWebGLToCanvasSize: boolean;
  devicePixelRatio: number;
  /** Passed to the canvas's getContext; the loader's defaults apply to what is not given. */
  webglContextAttributes?: WebGLContextAttributes;
}

export default UnityConfig;
